import React from "react";
import { useParams } from "react-router-dom";
import { useData } from "../../../../../components/SiteMap/contexts/DataContext";
import SiteMapTextRoute from "../../../../../components/SiteMap/routes/TextRoute";

const SiteMapTextPage = () => {
  const { textId } = useParams();
  const { labelMarkers } = useData();

  const text = labelMarkers.find(
    (text) => textId && text.id === parseInt(textId),
  );

  return (
    <>
      <SiteMapTextRoute text={text} />
    </>
  );
};

export default SiteMapTextPage;
